// extracted by mini-css-extract-plugin
export var textInput = "_ds-0";